export class Controller {

    /** @ngInject */
    constructor(
        AuthenticationPoliciesService,
        Alert,
        $state
        ) {
        this.Alert= Alert;
        this.$state= $state;
        this.AuthenticationPoliciesService = AuthenticationPoliciesService;
    }

    $onInit() {
        this.newAuthSettings = angular.copy(this.currentPasswordAuthenticationSettings);
        this.selectedPolicy = this.newAuthSettings.passwordPolicyId != null ? this.newAuthSettings.companyPasswordPolicies.find(p => p.passwordPolicyId === this.newAuthSettings.passwordPolicyId) : this.newAuthSettings.companyPasswordPolicies.find(p => p.passwordPolicyName === "Default Policy");
        this.pap = this.selectedPolicy;
        if (this.application.applicationType.slug==='google-apps'){
            //this.newAuthSettings.passwordAuthenticationOnGoogle=true;
        }
    }

    is(...types) {
        return types.includes(this.application.applicationType.slug);
    }

    saveDisabled() {
        return this.isSaving || this.notModified();
    }


    notModified(){
        let pwPolicyNotModified = this.currentPasswordAuthenticationSettings.passwordPolicyId === this.selectedPolicy.passwordPolicyId || this.currentPasswordAuthenticationSettings.passwordPolicyId == null && !this.newAuthSettings.enablePasswordAuthentication;
        return pwPolicyNotModified && (angular.equals(this.newAuthSettings,this.currentPasswordAuthenticationSettings))
    }

    save(){
        this.newAuthSettings.passwordPolicyId=this.selectedPolicy.passwordPolicyId;
        this.isSaving = true;
        if (this.application.applicationType.slug==='google-apps'){
            this.settings={
                "enablePasswordAuthentication": this.newAuthSettings.enablePasswordAuthentication,
                "passwordAuthenticationOnGoogle": this.newAuthSettings.enablePasswordAuthentication===false ? null : this.newAuthSettings.passwordAuthenticationOnGoogle,
                "passwordPolicyId": this.newAuthSettings.passwordAuthenticationOnGoogle === false ? this.selectedPolicy.passwordPolicyId : null,
                "enableOnPremisesAdAuthentication": this.newAuthSettings.enablePasswordAuthentication===false ? false :this.newAuthSettings.enableOnPremisesAdAuthentication,
                "notAssignedAccountLoginSetting": this.newAuthSettings.notAssignedAccountLoginSetting,
                "pendingAssignedAccountLoginSetting": this.newAuthSettings.pendingAssignedAccountLoginSetting,
                "notExistAccountLoginSetting": this.newAuthSettings.notExistAccountLoginSetting,
            }
        }
        else {
            if (this.newAuthSettings.enablePasswordAuthentication === false) {
                this.settings = {
                    "enableOnPremisesAdAuthentication": false,
                    "enablePasswordAuthentication": false,
                    "notAssignedAccountLoginSetting": null,
                    "notExistAccountLoginSetting": null,
                    "passwordAuthenticationOnGoogle": null,
                    "passwordPolicyId": null,
                    "pendingAssignedAccountLoginSetting": null
                }
            }
            else this.settings = this.newAuthSettings;
        }

        this.AuthenticationPoliciesService.UpdateCurrentPasswordAuthenticationSettings(this.companyId,this.application.id,this.settings)
            .then(() => this.Alert('success', 'company.policies.settings_updated'))
            .then(() => this.$state.reload('company.manage-application'))
            .finally(() => this.isSaving = false)
    }

}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/authentication-policies/password-policy/password-policy.controller.js